module.exports = __webpack_public_path__ + "img/quicksplain_text.f5aaff59.svg";